export function emptyObject(obj){
	return Object.keys(obj).length === 0
}